import React, { useEffect, useState } from "react";
import $ from 'jquery';
import { useSelector } from 'react-redux';
import { selectIsAdmin, selectIsMaster } from "../../../features/auth/authSlice";
import PasswordChange from "./PasswordChange";
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useChangeAvatarMutation, useChangeProfileNameMutation } from "../../../features/user/userApiSlice";
import { useTranslation } from 'react-i18next';
import EmailVerification from "./EmailVerification";
import Documents from "./MasterComponents/Documents";
import UploadDocuments from "./MasterComponents/UploadDocuments";
import ProfileSettings from "./MasterComponents/ProfileSettings";
import { setNewAvatar, setProfileName } from "../../../features/auth/authSlice";
import { useDispatch } from "react-redux";
import LocationPermission from "./MasterComponents/LocationPermission";
import { useGetInfoQuery } from "../../../features/user/userApiSlice";
import { useGetMasterDocumentsQuery } from "../../../features/master/masterApiSlice";

const schema = yup
    .object()
    .shape({
        // name: yup.string().required(),
        // age: yup.number().required(),
        avatarPhoto: yup.mixed()
            .test("fileSize", "File Size is too large", (value) => {
                return value.length && value[0].size <= 5242880;
            })
            .test("fileType", "Unsupported File Format", (value) => {
                return value.length && ["image/jpeg", "image/png", "image/jpg"].includes(value[0].type)
            })
    })
    .required();

let Settings = (props) => {
    const { t } = useTranslation();
    const { register, handleSubmit, reset, watch,
        formState: { errors },
    } = useForm({ resolver: yupResolver(schema) });

    const isMaster = useSelector(selectIsMaster);
    const isAdmin = useSelector(selectIsAdmin);
    const { data: info } = useGetInfoQuery();
    const { id, firstName, lastName, avatar, phone, email, isEmailVerified,
        masterInfo
    } = info || {};
    const [avatarPhoto, setAvatarPhoto] = useState(avatar);
    const { data: documentData, isLoading: isDocumentsLoading } = useGetMasterDocumentsQuery(undefined, { skip: !isMaster });
    const documents = documentData?.documents || [];
    const { tagLine, description, categories } = masterInfo || {};
    //const location = useLocation();
    const [changeAvatar, { isLoading: isAvatarUploading }] = useChangeAvatarMutation();
    const [changeProfileName, { isLoading: isSavingName }] = useChangeProfileNameMutation();
    const dispatch = useDispatch();
    const [newFirstName, setNewFirstName] = useState('');
    const [newLastName, setNewLastName] = useState('');
    const [newPhone, setNewPhone] = useState('');
    const [profileMessage, setProfileMessage] = useState(null);
    const [avatarMessage, setAvatarMessage] = useState(null);

    const profilePhotosPath = process.env.REACT_APP_PROFILE_PHOTOS_PATH;

    useEffect(() => {
        if (avatar) {
            setAvatarPhoto(avatar);
        }
    }, [avatar]);

    useEffect(() => {
        setNewFirstName(firstName || '');
        setNewLastName(lastName || '');
        setNewPhone(phone || '');
    }, [firstName, lastName, phone]);

    useEffect(() => {

        // Mobile Adjustment for Single Button Icon in Dashboard Box
        $('.buttons-to-right').each(function () {
            var btr = $(this).width();
            if (btr < 36) {
                $(this).addClass('single-right-button');
            }
        });

        //avatarSwitcher();
    }, []);

    const onAvatarChange = async ({ target }) => {
        const file = target.files?.[0];
        target.value = '';
        setAvatarMessage(null);
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
            setAvatarMessage({ type: 'error', text: t('UnsupportedAvatarFormat') });
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            setAvatarMessage({ type: 'error', text: t('AvatarFileTooLarge') });
            return;
        }

        try {
            const formData = new FormData();
            formData.append('avatar', file, file.name);

            const res = await changeAvatar(formData)
                .unwrap();

            dispatch(setNewAvatar(res.path));

            setAvatarPhoto(res.path);
            setAvatarMessage({ type: 'success', text: t('AvatarUpdatedSuccessfully') });

        } catch (error) {
            setAvatarMessage({ type: 'error', text: t(error?.data?.message || 'AvatarUploadFailed') });
        }
    };

    const onProfileNameSubmit = async event => {
        event.preventDefault();
        setProfileMessage(null);

        const normalizedFirstName = newFirstName.trim();
        const normalizedLastName = newLastName.trim();
        const normalizedPhone = newPhone.trim().replace(/[\s()-]/g, '');

        if (!normalizedFirstName || !normalizedLastName) {
            setProfileMessage({ type: 'error', text: t('FirstAndLastNameAreRequired') });
            return;
        }

        if (!/^\+[1-9]\d{7,14}$/.test(normalizedPhone)) {
            setProfileMessage({ type: 'error', text: t('InvalidPhoneNumberFormat') });
            return;
        }

        try {
            const result = await changeProfileName({
                firstName: normalizedFirstName,
                lastName: normalizedLastName,
                phone: normalizedPhone
            }).unwrap();

            dispatch(setProfileName(result));
            setNewFirstName(result.firstName);
            setNewLastName(result.lastName);
            setNewPhone(result.phone);
            setProfileMessage({ type: 'success', text: t('YourDataHasBeenSuccessfullyUpdated') });
        } catch (error) {
            setProfileMessage({ type: 'error', text: t(error?.data?.message || 'CouldNotUpdateProfile') });
        }
    };

    return <div className="row">

        {!isAdmin &&
            <>
                <div className="col-xl-12">
                    <div className="dashboard-box margin-top-0">

                        <div className="headline">
                            <h3><i className="icon-material-outline-account-circle"></i> {t('MyAccount')}</h3>
                        </div>

                        <div className="content with-padding padding-bottom-0">

                            <div className="row">

                                <div className="col-auto">

                                <div className="avatar-wrapper" data-tippy-placement="bottom" title="Change Avatar">
                                    <img className="profile-pic" src={`${profilePhotosPath}${avatarPhoto}?`+ new Date().getTime()} alt="" />
                                    {isAvatarUploading && <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,.72)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5, fontWeight: 600 }}>{t('Uploading')}</div>}
                                    <div className="upload-button">
                                        <input name="avatarPhoto"
                                            {...register('avatarPhoto')}
                                            className="file-upload" type="file" accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp" onChange={onAvatarChange} disabled={isAvatarUploading} />
                                    </div>

                                </div>
                                {avatarMessage && <div role="status" style={{ maxWidth: '180px', marginTop: '8px', color: avatarMessage.type === 'success' ? '#14834b' : '#d93025', fontSize: '13px', lineHeight: 1.35 }}>{avatarMessage.text}</div>}
                                </div>

                                <div className="col">
                                    <form onSubmit={onProfileNameSubmit}>
                                    <div className="row">

                                        <div className="col-xl-6">
                                            <div className="submit-field">
                                                <h5>{t("FirstName")}</h5>
                                                <input type="text" className="with-border" maxLength="50" required value={newFirstName} onChange={event => setNewFirstName(event.target.value)} />
                                            </div>
                                        </div>

                                        <div className="col-xl-6">
                                            <div className="submit-field">
                                                <h5>{t("LastName")}</h5>
                                                <input type="text" className="with-border" maxLength="50" required value={newLastName} onChange={event => setNewLastName(event.target.value)} />
                                            </div>
                                        </div>

                                        <div className="col-xl-6">
                                            <div className="submit-field">
                                                <h5>{t("AccountType")}</h5>
                                                <div className="account-type">
                                                {!isMaster
                                                    ? <div>
                                                        <input readOnly type="radio" name="account-type-radio" id="client-radio" className="account-type-radio" checked={!isMaster} onChange={() => { }} />
                                                        <label htmlFor="client-radio" className="ripple-effect-dark"><i className="icon-material-outline-account-circle"></i> {t("Client")}</label>
                                                    </div>

                                                    : <div>
                                                        <input readOnly type="radio" name="account-type-radio" id="master-radio" className="account-type-radio" checked={isMaster} onChange={() => { }} />
                                                        <label htmlFor="master-radio" className="ripple-effect-dark"><i className="icon-material-outline-business-center"></i> {t("Master")}</label>
                                                    </div>
                                                }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-6">
                                            <div className="submit-field">
                                                <h5>{t("Phone")}</h5>
                                                <input type="tel" className="with-border" required inputMode="tel" autoComplete="tel" placeholder="+420123456789" value={newPhone} onChange={event => setNewPhone(event.target.value)} />
                                            </div>
                                        </div>

                                        {!!+isEmailVerified 
                                            ? <div className="col-xl-6">
                                                <div className="submit-field">
                                                    <h5>Email</h5>
                                                    <input readOnly type="text" className="with-border" value={email} onChange={() => { }} />
                                                </div>
                                            </div>
                                            : null
                                        }
                                        <div className="col-xl-12 margin-bottom-20">
                                            <button type="submit" className="button ripple-effect" disabled={isSavingName}>
                                                {isSavingName ? t('Saving') : t('SaveChanges')}
                                            </button>
                                            {profileMessage && <span style={{
                                                display: 'inline-block',
                                                marginLeft: '15px',
                                                color: profileMessage.type === 'success' ? '#2a9d50' : '#d93025'
                                            }}>{profileMessage.text}</span>}
                                        </div>
                                    </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {!(!!+isEmailVerified)
                    ? <EmailVerification email={email} />
                    : null
                }

                {!!+isMaster
                    ? <>
                    
                        {true
                            ? <LocationPermission />
                            : null
                        }

                        <div className="col-xl-12">
                            <div className="dashboard-box" style={{ boxShadow: documents.length === 0 ? '0 2px 8px rgba(255,0,0,0.2)' : '' }}>
                                <div className="headline" style={{ borderBottomColor: documents.length === 0 ? 'rgba(255,0,0,0.2)' : '' }}>
                                    <h3><i style={{ color: documents.length === 0 ? 'red' : '' }} className="icon-material-outline-assignment"></i> {t("MyDocuments")}</h3>
                                </div>

                                <div className="content with-padding">
                                    <div className="row">
                                        {!isDocumentsLoading && documents.length > 0 && <>
                                            <Documents documents={documents} />
                                            <p className="col-xl-12"><strong>{documentData?.isAdminChecked ? t('Verified') : t('DocumentsPendingReview')}</strong></p>
                                        </>}
                                        {!isDocumentsLoading && <UploadDocuments existingDocuments={documents} />}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ProfileSettings categories={categories} tagLine={tagLine} description={description} />

                    </>
                    : null}
            </>}

        {false && <PasswordChange />}
    </div>;
}

export default Settings;
